import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import AppointmentService from '../utils/AppointmentService.js';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import InjectedCCForm from "../Components/InjectedCCForm.js"
import {Elements} from 'react-stripe-elements';

//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class NewCCForm extends Component {
  constructor(props) {
    super(props)
    this.state ={
      ccNumber: '',
      expMonth: '',
      expYear: '',
      cvc:'',
      cardName:'',
      ccError: '',
      formError: this.props.ccErrors,
      isLoading: false,
      billingZipcode: '',
      closeModal: this.props.closeModal,
      afterSave: this.props.afterSave,
      onLoad: this.props.onLoad
    }

  }
  render() {
    return (
      <div>
        <Elements>
            <InjectedCCForm closeModal={this.props.closeModal} afterSave={this.state.afterSave} onLoad={this.state.onLoad}/>
        </Elements>
      </div>
    )
  }
}
export default NewCCForm



// WEBPACK FOOTER //
// ./src/Components/NewCCForm.js